import React from "react";

const FaceThreading = () => {
  return (
    <div className="faceWaxingContainer">
      <h2>Threading at SCENT</h2>
      <h3>Precision Hair Removal</h3>
      <p>
        Threading is an ancient hair removal technique that offers precision and
        control, making it ideal for shaping eyebrows and removing unwanted
        facial hair.
      </p>
      <h3>Benefits of Threading</h3>
      <li>
        <h6>Precision :</h6>Threading allows for precise shaping of the eyebrows
        and removal of hair, giving you a polished look.
      </li>
      <li>
        <h6>Gentle on the Skin:</h6> This technique is gentle on the skin,
        making it suitable for sensitive areas.
      </li>
      <li>
        <h6>No Chemicals:</h6> Threading does not involve any chemicals, making
        it a natural and safe option for hair removal.
      </li>
      <h3>Our Threading Process</h3>
      <li>
        <h6>1. Consultation:</h6>We begin with a consultation to understand your
        preferences and the shape you desire.
      </li>
      <li>
        <h6>2. Threading:</h6> Using a thin thread, we remove unwanted hair with
        precision, ensuring a clean and defined look.
      </li>
      <li>
        <h6>3. Aftercare:</h6> Post-threading, we apply soothing products to
        calm the skin and prevent any irritation.
      </li>
    </div>
  );
};

export default FaceThreading;
